import { IDestroyOptions, Sprite } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../../common/components/ButtonWithScaleAnimation";
import { SoundsResourcePackageWrapper } from "../../../../common/resources/SoundsResourcePackageWrapper";
import { UserProfileResourcePackage } from "../../resources/UserProfileResourcePackage";
import { ISettingsModel } from "by/gamefactory/cityversetycoon/settings/ISettingsModel";
import { ISettingsController } from "by/gamefactory/cityversetycoon/settings/ISettingsController";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { CheckBox } from "by/gamefactory/cityversetycoon/scenes/common/components/CheckBox";

export class VolumeButton extends ButtonWithScaleAnimation {
    private readonly userProfileResources: UserProfileResourcePackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly settingsModel: ISettingsModel;
    private readonly settingsController: ISettingsController;
    private readonly logger: ILogger;
    private soundSwitchButton: CheckBox;

    public constructor(
        userProfileResources: UserProfileResourcePackage,
        settingsModel: ISettingsModel,
        settingsController: ISettingsController,
        soundResources: SoundsResourcePackageWrapper,
        logger: ILogger
    ) {
        super(userProfileResources.assets_views_user_profile_volume_icon_png);
        this.userProfileResources = userProfileResources;
        this.settingsModel = settingsModel;
        this.settingsController = settingsController;
        this.soundResources = soundResources;
        this.logger = logger;
        this.onUp.add(this.clickHandle, this);
        this.build();
    }

    private build(): void {
        this.soundSwitchButton = new CheckBox({
            checked: this.settingsModel.soundEnabled.value,
            style: {
                unchecked: new Sprite(this.userProfileResources.assets_views_user_profile_switch_off_png),
                checked: new Sprite(this.userProfileResources.assets_views_user_profile_switch_on_png)
            }
        });
        this.soundSwitchButton.position.set(23, 149);
        this.addChild(this.soundSwitchButton);
    }

    private async clickHandle(): Promise<void> {
        this.eventMode = "auto";
        try {
            this.settingsController.switchSoundEnabled();
            await this.soundResources.assets_sounds_Choose_Card_mp3.play();
            this.soundSwitchButton.checked = this.settingsModel.soundEnabled.value;
        } catch (error: unknown) {
            this.logger.error(error);
        } finally {
            this.eventMode = "static";
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.clickHandle, this);
        super.destroy(options);
    }
}
